import React from 'react';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import {useTranslation} from "react-i18next";

const ConfirmDialog = ({handleCancel, handleApprove, isOpen}) => {
    const {t} = useTranslation()
    return <Dialog
        dir={'ltr'}
        open={isOpen}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title2"
        aria-describedby="alert-dialog-description2"
    >
        <DialogTitle id="alert-dialog-title2">{t('cancel-appointment')}</DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-description2">
                {t('are-you-sure-cancel-appointment')}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleCancel} color="primary" variant={"outlined"}>
                {t('doesnt-matter')}
            </Button>
            <Button onClick={handleApprove} color="primary" variant={"contained"} autoFocus>
                {t('cancel-meeting')}
            </Button>
        </DialogActions>
    </Dialog>
}

export default ConfirmDialog;